import React, {useState, useEffect} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";
import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import SelectPlantonistaModal from "./SelectPlantonistaModal";
import moment from "moment";
import "moment/locale/pt-br";
import locale from "antd/es/date-picker/locale/pt_BR"; // Importando o locale do antd
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
import './assets/css/Duty.css';
import dayjs from 'dayjs';
import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import ImportModal from "../import/ImportModal";
import CustomPagination from "../util/CustomPagination";
import DutyDetailModal from "../dashboard/calender/dutyDetailModal";
import PlantaoRepostModal from "../dashboard/calender/plantaoRepostModal";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

const {RangePicker} = DatePicker;


moment.locale('pt-br');

const MyDuty = () => {

    document.title = "Meu Plantão | Plantão Rápido";
    const user = AuthService.getUserData();
    const [options, setOptions] = useState([]);



    const [duty, setDuty] = useState([]);// Estado para o dever selecionado

    const [showDutyModal, setShowDutyModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);


    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedDuty, setSelectedDuty] = useState(null);
    const [filters, setFilters] = useState({
        dateRange: "",
        status: "",
        hospital: "",
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    useEffect(() => {
        fetchDuties(pagination.current, false);
    }, [pagination.current]);


    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchDuties = async (page = 1, isExport = false) => {

        if (!isExport) {
            setLoading(true);
        }

        try {
            // Define o responseType baseado em isExport
            const responseType = isExport ? 'blob' : 'json';

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}duty/duty-record`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    datestart: filters.datestart ? filters.datestart : null,
                    dateend: filters.dateend ? filters.dateend : null,
                    status: filters.status,
                    hospital: filters.hospital,
                    allCompany: true,
                    myDuty: true,
                    isExport
                },
                true,
                responseType // Usa a lógica do json e blob
            );

            if (isExport) {
                // Processa exportação de arquivo
                const blob = new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = `export_${new Date().toISOString().split("T")[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Se não for exportação, trata a resposta JSON normalmente

                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setDuties(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDutyClick = (duty) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handlePlantaoModalClose = () => {
        setShowDutyModal(false);
    };
    const handlePlantaoRepostModalClose = () => {
        setShowPlantaoRepostModal(false);
    };


    const handleDelete = async (dutyId) => {
        try {
            const result = await Swal.fire({
                title: 'Tem certeza?',
                text: "Você não poderá reverter isso!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, deletar!',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                await ApiService.send("delete", process.env.REACT_APP_URL_API + "duty/delete", {id: dutyId});
                setDuties(duties.filter(duty => duty.id !== dutyId)); // Remove the duty from the list
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Plantão deletado com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleModalOpen = (duty = null) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalClose = (save = false) => {
        setModalVisible(false);
        setSelectedDuty(null);
        if(save) {
            fetchDuties(); // Refresh the list after modal is closed
        }
    };

    const handleSelectPlantonistaOpen = (duty) => {
        setSelectedDuty(duty);
        setSelectPlantonistaVisible(true);
    };


    const handlePlantonistaSelected = async (plantonistaId) => {
        try {
            await ApiService.send("post", `${process.env.REACT_APP_URL_API}duty/accept`, {
                dutyId: selectedDuty.id,
                userId: plantonistaId,
            });
            Swal.fire({
                title: 'Sucesso!',
                text: 'Plantonista selecionado com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            fetchDuties();
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setSelectPlantonistaVisible(false);
        }
    };

    const handleFilterChange = (changedFilters) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...changedFilters,
        }));
    };

    const handleSearch = () => {
        setPagination({...pagination, current: 1});
        fetchDuties();
    };

    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            status: "",
            hospital: "",
        });
        setPagination({...pagination, current: 1});
        fetchDuties();
    };

    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            handleFilterChange({hospital: hospital.value});
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            handleFilterChange({hospital: null});
        }
    };


    const calculateDuration = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const duration = intervalToDuration({start: startDate, end: endDate});
        return formatDuration(duration, {format: ["hours", "minutes"], locale: ptBR});
    };


    const handleSearchFiltersChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    const fetchCompanies = async () => {
        try {
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}users/my-list-companies`, // Altere conforme o endpoint real
                {},
                true
            );

            const { data } = ApiService.handleApiResponse(response);

            const companyOptions = data.map((company) => ({
                value: company.id,
                label: company.name,
            }));

            setOptions(companyOptions);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Meus" pageTitle="Plantão"/>
                    <Row>



                                                <div className="row mt-4 mb-4">
                                                    <div className="col-md-4">
                                                        <div className="form-group ">
                                                            <label>Data</label>
                                                            <div className="form-control">
                                                                <RangePicker
                                                                    style={{border: "none", boxShadow: "none"}}
                                                                    locale={locale}
                                                                    format="DD/MM/YYYY"
                                                                    className="range-picker-custom"
                                                                    value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                                                    onChange={(dates) => {
                                                                        if (dates) {
                                                                            handleSearchFiltersChange("dateRange", dates);
                                                                            handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                                            handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                                        } else {
                                                                            handleSearchFiltersChange("dateRange", []);
                                                                            handleSearchFiltersChange("datestart", null);
                                                                            handleSearchFiltersChange("dateend", null);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <HospitalSearch buttonAdd={false}
                                                                        onHospitalSelect={onHospitalSelect}

                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label>Empresa</label>
                                                            <Select
                                                                id="companySelect"
                                                                classNamePrefix="react-select"
                                                                options={options}
                                                                value={filters.company || null}
                                                                placeholder="Selecione..."
                                                                onChange={(selectedOption) =>
                                                                    handleSearchFiltersChange('company', selectedOption)
                                                                }
                                                                isClearable
                                                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                                styles={{
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    }), // Definindo z-index alto
                                                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <div className="col-md-12 d-flex justify-content-end">
                                                        <button type="button" className="btn  mr-1  me-2"
                                                                onClick={() =>handleClearFilters()}>
                                                            <i className="fa fa-eraser"></i> Limpar Filtros
                                                        </button>
                                                        <button type="button" className="btn btn-dark btn-s mr-1 me-2"
                                                                onClick={() => fetchDuties(1, true)}>
                                                            <i className="fa fa-file-excel-o"></i> Exportar
                                                        </button>

                                                        <button type="button" className="btn btn-success"
                                                                onClick={() => fetchDuties(1, false)}>
                                                            <i className="fa fa-search"></i> Buscar
                                                        </button>
                                                    </div>
                                                </div>



                                        <div className="list-container mt-4">
                                            {loading ? (
                                                <>
                                                    <div className="card duty-card shadow-sm mb-3">
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-3">
                                                                    <Skeleton width={150} height={150}/>
                                                                </div>
                                                                <div className="col-9">
                                                                    <Skeleton width={200}/>
                                                                    <p>
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                    <p className="card-text">
                                                                        <Skeleton width={200}/>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                duties.length > 0 ? (

                                                    duties.map((duty) => (
                                                        <Col lg={12} key={duty.id}>
                                                            <Card className="mb-2 p-1 shadow-sm card-hover duty-card" key={duty.id}>
                                                                <CardBody
                                                                    className="p-2 d-flex justify-content-between align-items-start">
                                                                    <div className="col-9 d-flex">
                                                                        <img
                                                                            src={duty.hospital?.images[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                                            alt={duty.hospital?.name || "Hospital"}
                                                                            style={{
                                                                                width: 60,
                                                                                height: 60,
                                                                                objectFit: "cover"
                                                                            }}
                                                                            className="rounded me-3"
                                                                        />
                                                                        <div className="w-100">
                                                                            <h6 className="mb-1"
                                                                                style={{fontSize: "0.95rem"}}>{duty.hospital?.name}</h6>
                                                                            <p className="mb-1"
                                                                               style={{fontSize: "0.8rem"}}>
                                                                                <i className="fa fa-map-marker text-info me-1"></i>
                                                                                {duty.hospital?.city?.name}, {duty.hospital?.uf} &nbsp;
                                                                                {duty.department?.name && (
                                                                                    <><i
                                                                                        className="fa fa-building text-info me-1"></i>{duty.department.name}</>
                                                                                )}
                                                                            </p>
                                                                            <p className="mb-1"
                                                                               style={{fontSize: "0.8rem"}}>
                                                                                <i className="fa fa-hourglass text-info me-1"
                                                                                   aria-hidden="true"></i>
                                                                                {calculateDuration(duty.date_time, duty.date_time_end)}
                                                                            </p>
                                                                            <div>
                                                                            {duty.specialties?.map((s) => (
                                                                                    <Tag key={s.id} color="blue"
                                                                                         style={{fontSize: "0.75rem"}}>{s.name}</Tag>
                                                                                ))}
                                                                            </div>
                                                                            <p className="text-muted mb-1">
                                                                                <i className="fa fa-calendar text-info"
                                                                                   style={{marginRight: "8px"}}></i>
                                                                                {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                                                {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                })}
                                                                                &nbsp;&nbsp;&nbsp;&nbsp;

                                                                                {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                                                {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                })}
                                                                            </p>
                                                                            {duty.observation && (
                                                                                <p className="text-muted mt-1"
                                                                                   style={{fontSize: "0.75rem"}}>
                                                                                    <i className="far fa-file-alt text-info me-1"></i>
                                                                                    {duty.observation.length > 60 ? `${duty.observation.slice(0, 60)}...` : duty.observation}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3 text-end">

                                                                        <div
                                                                            className="d-flex justify-content-between align-items-center mb-2">
                                                                            {duty.accept_user && (
                                                                                <div
                                                                                    className="d-flex align-items-end justify-content-end mb-2">
                                                                                    <Avatar
                                                                                        src={duty.accept_user.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                                        size={30}
                                                                                        className="me-2" // Adicionando margem à direita do Avatar para espaçamento
                                                                                        // Adicionando margem à direita do Avatar para espaçamento
                                                                                    />
                                                                                    <span
                                                                                        style={{fontSize: "0.85rem"}}>{duty.accept_user.name}</span>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <p className="text-success fw-bold mb-2"
                                                                           style={{fontSize: "1rem"}}>
                                                                            {new Intl.NumberFormat("pt-BR", {
                                                                                style: "currency",
                                                                                currency: "BRL"
                                                                            }).format(duty.value)}
                                                                        </p>

                                                                            <button type="button"
                                                                                className="btn btn-outline-info btn-sm me-2 mb-2"
                                                                                onClick={() => handleDutyClick(duty)}>
                                                                                <i className="fa fa-list"></i> Detalhes
                                                                            </button>

                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            new Date(duty.date_time_end) <= new Date() ? (
                                                                                                <Tooltip id={`tooltip-disabled-${duty.id}`}>
                                                                                                    Só é possível repostar plantões com data e hora futuras
                                                                                                </Tooltip>
                                                                                            ) : (
                                                                                                <></>
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                          <span className="d-inline-block">
                                                                                            <button type="button"
                                                                                                className="btn btn-warning btn-sm me-2 mb-2"
                                                                                                disabled={new Date(duty.date_time_end) <= new Date()}
                                                                                                style={
                                                                                                    new Date(duty.date_time_end) <= new Date()
                                                                                                        ? { pointerEvents: "none" }
                                                                                                        : {}
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    if (new Date(duty.date_time_end) > new Date()) {
                                                                                                        setSelectedDuty(false);
                                                                                                        setDuty(duty);
                                                                                                        setShowPlantaoRepostModal(true);
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                              <i className="fa fa-exchange"></i> Repostar
                                                                                            </button>
                                                                                          </span>
                                                                            </OverlayTrigger>



                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))
                                                ) : (
                                                    <div className=" duty-card shadow-sm mb-3">
                                                        <div className="alert alert-primary" role="alert">Nenhum plantão
                                                            encontrado.

                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <CustomPagination
                                            className="mt-4"
                                            pagination={pagination}
                                            onChange={(page) => setPagination({...pagination, current: page})}
                                        />



                        {selectedDuty && (
                            <DutyDetailModal
                                show={modalVisible}
                                handleClose={handleModalClose}
                                eventDetails={selectedDuty}
                                onRepost={(event) => {
                                    setSelectedDuty(false);
                                    setDuty(event);
                                    setShowPlantaoRepostModal(true);
                                }}
                                onEdit={(event) => {
                                    setSelectedDuty(false);
                                    setDuty(event);
                                    setShowDutyModal(true);
                                }}
                            />
                        )}

                        {/* Modal de cadastro de plantão */}
                        {showDutyModal && (
                            <PlantaoModal
                                show={showDutyModal}
                                handleClose={handlePlantaoModalClose}
                                duty={duty}
                            />
                        )}

                        {showPlantaoRepostModal && (
                            <PlantaoRepostModal
                                show={showPlantaoRepostModal}
                                handleClose={handlePlantaoRepostModalClose}
                                duty={duty}
                            />
                        )}


                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MyDuty;
